import React from "react";
import PropTypes from "prop-types";
import NavBar from "../containers/NavBar";
import Footer from "../components/Footer/Footer";
import "./PageLayout.scss";

class PageLayout extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document
      .getElementsByClassName("react-openlayers--map")[0]
      .classList.add("hide-map");
  }

  render() {
    const { children } = this.props;
    return (
      <div className="page-layout--root">
        <NavBar />
        <div className="page-layout--container">
          <div className="page-layout--components">{children}</div>
        </div>
        <Footer />
      </div>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.element,
};

export default PageLayout;
